import { inject, ref, type Ref } from 'vue'
import type { Element } from '../types'

export const CARD_CONTEXT_KEYS = {
  inputs: 'ac-inputs',
  errors: 'ac-errors',
  elements: 'ac-elements',
  cardWidth: 'ac-card-width',
  cardInstanceId: 'ac-card-instance-id',
  visibility: 'ac-visibility',
  toggleVisibility: 'ac-toggle-visibility',
  isEnabled: 'ac-is-enabled',
  setEnabled: 'ac-set-enabled',
} as const

export function useCardContext() {
  const inputs = inject<Record<string, string>>(CARD_CONTEXT_KEYS.inputs, {})
  const errors = inject<Record<string, string>>(CARD_CONTEXT_KEYS.errors, {})
  const elements = inject<Element[]>(CARD_CONTEXT_KEYS.elements, [])
  const cardWidth = inject<Ref<number>>(CARD_CONTEXT_KEYS.cardWidth, ref(800))
  const cardInstanceId = inject<string>(CARD_CONTEXT_KEYS.cardInstanceId, 'ac-card')
  const visibility = inject<Record<string, boolean>>(CARD_CONTEXT_KEYS.visibility, {})
  const toggleVisibility = inject<(elementId: string, isVisible?: boolean) => void>(
    CARD_CONTEXT_KEYS.toggleVisibility,
    () => {}
  )
  const isEnabled = inject<Ref<boolean>>(CARD_CONTEXT_KEYS.isEnabled, ref(true))
  const setEnabled = inject<(value: boolean) => void>(CARD_CONTEXT_KEYS.setEnabled, () => {})

  return {
    inputs,
    errors,
    elements,
    cardWidth,
    cardInstanceId,
    visibility,
    toggleVisibility,
    isEnabled,
    setEnabled,
  }
}
